/**
 * VT_Counter
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade module to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to https://github.com/Volga for more information.
 *
 * @author    Volga https://github.com/Volga
 * @copyright (c) 2018 Vladimir Tikunov. All Rights Reserved.
 * @license   http://www.gnu.org/licenses/gpl-2.0.html GNU/GPL
 *
 * @ru Не редактируйте этот файл, если вы планируете обновить модуль до новых
 * @ru версии в будущем. Если вам необходимо настроить и/или доработать PrestaShop
 * @ru под ваши потребности, пожалуйста, обратитесь к https://github.com/Volga
 * @ru для получения дополнительной информации.
 *
 */

import $ from "jquery";

window.vtEvents = (function () {
    let eventNode = $({});
    return {
        on: on,
        trigger: trigger
    };

    function on() {
        eventNode.on.apply(eventNode, arguments);
    }

    function trigger() {
        eventNode.trigger.apply(eventNode, arguments);
    }
})();


$(document).ready(() => {
    function sendClientId() {
        let clientId = window.vtYaCounter.getClientID();
        let clientIdUrl = window.vtYaCounterClientIDUrl;

        let data = {};

        data.clientID = clientId;


        if (typeof goCounter === 'object') {
            data.gaClientID = goCounter.get('clientId');
        }

        $.post(clientIdUrl, data).then(function (resp) {
        }).fail(function (resp) {
        });
    }

    if ('getClientID' in window.vtYaCounter) {
        sendClientId();
    } else {
        $(document).on('yacounter' + window.vtYaCounterNumber + 'inited', sendClientId);
    }

    let productObject = $(".vt-counter-detail-product").data('vt-counter-product') || {};
    if (productObject.hasOwnProperty('id')) {
        gtag('event', 'select_content', {
            "content_type": "product",
            "items": [
                productObject
            ]
          });
        window.dataLayer.push({
            "ecommerce": {
                "detail": {
                    "products": [
                        productObject
                    ]
                }
            }
        });
    }

    let orderNode = $(".vt-counter-order");
    let orderProducts = orderNode.data('vt-counter-products') || [];
    let orderSummary = orderNode.data('vt-counter-order') || {};
    if (orderSummary.hasOwnProperty('id') && orderProducts.length) {
        let date = new Date();
        gtag('event', 'purchase', {
            "transaction_id":orderSummary['id'],
            "value": orderSummary['revenue'],
            "items": orderProducts
          });
        if(typeof gtag === 'undefined'){
        window.dataLayer.push({
            "ecommerce": {
                "purchase": {
                    "actionField": orderSummary,
                    "products": orderProducts
                }
            }
        });
    }
    setTimeout(function(){
        window.vtYaCounter.reachGoal("order");
        window.vtYaCounter.reachGoal("any_order");
        gtag('event', 'any_order',{'event_category': 'submit'});
        gtag('event', 'order',{'event_category': 'submit'});
    },500);
    }

    let body = $("body");
    body.on('mousedown', ".vt-counter-add-to-cart", function (e) {
        if (e.button === 0) {
            let productObject = $(e.currentTarget).data('vt-counter-product') || {};
            if (productObject.hasOwnProperty('id')) {
                productObject.quantity = productObject.quantity || 1;
                gtag('event', 'add_to_cart', {
                    "value":productObject['price'],
                    "items": [
                        productObject
                    ]
                  });
                if(typeof gtag === 'undefined'){
                window.dataLayer.push({
                    "ecommerce": {
                        "add": {
                            "products": [
                                productObject
                            ]
                        }
                    }
                });
            }
                window.vtYaCounter.reachGoal("add_to_cart");
            }
        }
    });

    body.on('mousedown', ".vt-counter-remove-from-cart", function (e) {
        if (e.button === 0) {
            let productObject = $(e.currentTarget).data('vt-counter-product') || {};
            if (productObject.hasOwnProperty('id')) {
                gtag('event', 'remove_from_cart', {
                    "value":productObject['price'],
                    "items": [
                        productObject
                    ]
                  });
                  if(typeof gtag === 'undefined'){
                window.dataLayer.push({
                    "ecommerce": {
                        "remove": {
                            "products": [
                                productObject
                            ]
                        }
                    }
                });
            }
            }
        }
    });

    $(".vt-counter-remove-all-from-cart").on('mousedown', function (e) {
        if (e.button === 0) {
            let productObject = $(e.currentTarget).data('vt-counter-product') || {};
            if (productObject.hasOwnProperty('id')) {
                delete productObject.quantity;
                gtag('event', 'remove_from_cart', {
                    "items": [
                        productObject
                    ]
                  });
            if(typeof gtag === 'undefined'){
                window.dataLayer.push({
                    "ecommerce": {
                        "remove": {
                            "products": [
                                productObject
                            ]
                        }
                    }
                });
            }
            }
        }
    });

    $('.phone-click').on('mousedown', function(e){
        window.vtYaCounter.reachGoal("phone_click");
    });

    window.vtEvents.on('removeFromCart', function (e, currentEvent) {
        let productObject = $(currentEvent.currentTarget).data('vt-counter-product') || {};
        if (productObject.hasOwnProperty('id')) {
            productObject.quantity = productObject.quantity || 1;
            gtag('event', 'remove_from_cart', {
                "value":productObject['price'],
                "items": [
                    productObject
                ]
              });
            window.dataLayer.push({
                "ecommerce": {
                    "remove": {
                        "products": [
                            productObject
                        ]
                    }
                }
            });
        }
    });

    window.vtEvents.on('order', function () {
        let productObject = $(".vt-counter-detail-product").data('vt-counter-product') || {};
        if (productObject.hasOwnProperty('id')) {
            let date = new Date();
            gtag('event', 'purchase', {
                "transaction_id": vtYaCounter.getClientID() + '-' + date.getTime(),
                "items": [
                    productObject
                ]
              });
            if(typeof gtag === 'undefined'){
            window.dataLayer.push({
                "ecommerce": {
                    "purchase": {
                        "actionField": {
                            "id": vtYaCounter.getClientID() + '-' + date.getTime()
                        },
                        "products": [
                            productObject
                        ]
                    }
                }
            });
        }
            window.vtYaCounter.reachGoal("any_order");
            gtag('event', 'any_order',{'event_category': 'submit'});
        }
    });

});


// WEBPACK FOOTER //
// ./_dev/vt_counter.js